import React from 'react'
import PropTypes from 'prop-types'

const CaseStudyContentBlock = (props) => {
    return (
        <>
            <div className="cs-maincontent">
                <h4>{props.title}</h4>
                <div dangerouslySetInnerHTML={{ __html: props.body }}></div>
            </div>

            {props.imageurl ? <img src={props.imageurl} alt={props.title} className="cs-maincontent-image" /> : ""}
        </>
    )
}

CaseStudyContentBlock.propTypes = {
    imageurl: PropTypes.string,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
}

export default CaseStudyContentBlock;